import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ProductReview from './pages/product-review';
import ComparisonTool from './pages/comparison-tool';
import DealTracker from './pages/deal-tracker';
import BuyingGuide from './pages/buying-guide';
import Homepage from './pages/homepage';
import AIReviewGenerator from './pages/admin/AIReviewGenerator';
import AdminLogin from './pages/admin-login';
import ReviewsListing from './pages/reviews';
import ReviewDetails from './pages/reviews/details';
import ProductReviews from './pages/product-reviews';
import AdminProductManagement from './pages/admin-product-management';
import AdminProductEdit from './pages/admin-product-edit';
import AdminDealManagement from './pages/admin-deal-management';
import AIBuyingGuideGenerator from './pages/ai-buying-guide-generator';
import AdminBuyingGuideManagement from './pages/admin-buying-guide-management';
import ProductListing from './pages/product-listing';
import SuperAdminAIGuideGenerator from './pages/super-admin-ai-guide-generator';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Homepage />} />
        <Route path="/product-review/:productId" element={<ProductReview />} />
        <Route path="/product-reviews" element={<ProductReviews />} />
        <Route path="/comparison-tool" element={<ComparisonTool />} />
        <Route path="/deal-tracker" element={<DealTracker />} />
        <Route path="/buying-guide" element={<BuyingGuide />} />
        <Route path="/product-listing" element={<ProductListing />} />
        <Route path="/homepage" element={<Homepage />} />
        <Route path="*" element={<NotFound />} />
        
        {/* Review Routes */}
        <Route path="/reviews" element={<ReviewsListing />} />
        <Route path="/reviews/:reviewId" element={<ReviewDetails />} />
        
        {/* Admin Routes */}
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/admin/ai-reviews" element={<AIReviewGenerator />} />
        <Route path="/admin/products" element={<AdminProductManagement />} />
        <Route path="/admin/products/:productId/edit" element={<AdminProductEdit />} />
        <Route path="/admin/deals" element={<AdminDealManagement />} />
        <Route path="/ai-buying-guide-generator" element={<AIBuyingGuideGenerator />} />
        <Route path="/admin/buying-guides" element={<AdminBuyingGuideManagement />} />
        <Route path="/super-admin-ai-guide-generator" element={<SuperAdminAIGuideGenerator />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;